var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, IsString, IsUUID, MaxLength, Min } from 'class-validator';
import { ExercisePerformanceType } from '../enums/exercise-performance-type.enum.js';
export class UpdateExerciseProgramItemDto {
    id;
    /*@IsNumber()
    @Min(0)
    @Expose()
    @IsOptional()
    sortIndex?: number;*/
    exerciseProgramId;
    exerciseId;
    performanceContent;
    performanceType;
    setCount;
    pauseDuration;
    weight;
    customIndication;
}
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateExerciseProgramItemDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateExerciseProgramItemDto.prototype, "exerciseProgramId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateExerciseProgramItemDto.prototype, "exerciseId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateExerciseProgramItemDto.prototype, "performanceContent", void 0);
__decorate([
    IsEnum(ExercisePerformanceType),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateExerciseProgramItemDto.prototype, "performanceType", void 0);
__decorate([
    IsNumber(),
    Expose(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateExerciseProgramItemDto.prototype, "setCount", void 0);
__decorate([
    IsNumber(),
    Min(1),
    IsOptional(),
    Expose(),
    __metadata("design:type", Number)
], UpdateExerciseProgramItemDto.prototype, "pauseDuration", void 0);
__decorate([
    IsNumber(),
    Min(1),
    IsOptional(),
    Expose(),
    __metadata("design:type", Number)
], UpdateExerciseProgramItemDto.prototype, "weight", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    MaxLength(255),
    __metadata("design:type", Object)
], UpdateExerciseProgramItemDto.prototype, "customIndication", void 0);
//# sourceMappingURL=update-exercise-program-item.dto.js.map